import { createFeatureSelector, createSelector } from '@ngrx/store';
import { onboardingFeatureKey, } from './onboarding.actions';
import { IOnboardingState } from './onboarding.reducers';

export const selectOnboardingState = createFeatureSelector<IOnboardingState>(onboardingFeatureKey);

export const selectOnboardingLoading = createSelector(
  selectOnboardingState,
  (state) => state.loading
);

export const selectOnboardingError = createSelector(
  selectOnboardingState,
  (state) => state.error
);

export const selectOnboardingSuccess = createSelector(
  selectOnboardingState,
  (state) => state.success
);

export const selectOnboardingResponse = createSelector(
  selectOnboardingState,
  (state) => state.onboardingResponse
);

// User Profile Selectors
export const selectUserProfileState = createSelector(
  selectOnboardingState,
  (state) => state.userProfile
);

export const selectUserProfileFirstName = createSelector(
  selectUserProfileState,
  (userProfile) => userProfile.firstName
);

export const selectUserProfileLastName = createSelector(
  selectUserProfileState,
  (userProfile) => userProfile.lastName
);

export const selectUserProfilePassword = createSelector(
  selectUserProfileState,
  (userProfile) => userProfile.password
);

export const selectUserProfileJobTitle = createSelector(
  selectUserProfileState,
  (userProfile) => userProfile.jobTitle
);

export const selectUserProfileCompanyName = createSelector(
  selectUserProfileState,
  (userProfile) => userProfile.companyName
);

export const selectUserProfilePhoneNumber = createSelector(
  selectUserProfileState,
  (userProfile) => userProfile.phoneNumber
);

export const selectUserProfileTerms = createSelector(
  selectUserProfileState,
  (userProfile) => userProfile.terms
);

export const selectUserProfileNoMarketing = createSelector(
  selectUserProfileState,
  (userProfile) => userProfile.noMarketing
);

export const selectUserProfileImagePreview = createSelector(
  selectUserProfileState,
  (userProfile) => userProfile.profileImagePreview
);

export const selectProfileImageFile = createSelector(
  selectUserProfileState,
  (userProfile) => userProfile.profileImageFile
);

export const selectUserProfilePasswordTextType = createSelector(
  selectUserProfileState,
  (userProfile) => userProfile.passwordTextType
);

export const selectUserProfileSubmitted = createSelector(
  selectUserProfileState,
  (userProfile) => userProfile.submitted
);

// Tell Us About You Selectors
export const selectTellUsAboutYouState = createSelector(
  selectOnboardingState,
  (state) => state.tellUsAboutYou
);

export const selectTellUsAboutYouWorkType = createSelector(
  selectTellUsAboutYouState,
  (tellUsAboutYou) => tellUsAboutYou.workType
);

// NEW: How Plan To Use Selectors
export const selectHowPlanToUseState = createSelector(
  selectOnboardingState,
  (state) => state.howPlanToUse
);

export const selectHowPlanToUsePlanningToUse = createSelector(
  selectHowPlanToUseState,
  (howPlanToUse) => howPlanToUse.planningToUse
);

export const selectOnboardingType = createSelector(
  selectOnboardingState,
  (state) => state.onboardingType
);

export const selectProfileStepSkipped = createSelector(
  selectOnboardingState,
  (state) => state.profileStepSkipped
);


export const selectIsOnboardingDataValid = createSelector(
  selectUserProfileState,
  selectTellUsAboutYouState,
  selectHowPlanToUseState,
  selectOnboardingType,
  selectProfileStepSkipped, // NEW: Add selectProfileStepSkipped
  (userProfile, tellUsAboutYou, howPlanToUse, onboardingType, profileStepSkipped) => {
    const isCommonValid =
      !!tellUsAboutYou.workType;

    if (onboardingType === 'invitation') {
      return isCommonValid &&
        !!userProfile.firstName &&
        !!userProfile.lastName &&
        !!userProfile.jobTitle &&
        !!userProfile.phoneNumber &&
        !!userProfile.password &&
        !!userProfile.terms &&
        userProfile.noMarketing !== null;
    } else if (onboardingType === 'customer') {
      if (profileStepSkipped) {
        return isCommonValid && !!howPlanToUse.planningToUse
      } else {
        return isCommonValid &&
          !!userProfile.jobTitle &&
          !!userProfile.phoneNumber &&
          !!userProfile.companyName &&
          !!howPlanToUse.planningToUse &&
          userProfile.noMarketing !== null;
      }
    }
    return false; // Should not happen if onboardingType is always set
  }
);

import { IOnboardingFormData } from './onboarding.dto';

export const selectOnboardingFormData = createSelector(
  selectUserProfileState,
  selectTellUsAboutYouState,
  selectHowPlanToUseState,
  selectOnboardingType,
  (userProfile, tellUsAboutYou, howPlanToUse, onboardingType): IOnboardingFormData => {
    const commonFormData = {
      workType: tellUsAboutYou.workType,
      jobTitle: userProfile.jobTitle,
      phoneNumber: userProfile.phoneNumber,
      noMarketing: userProfile.noMarketing,
      profileImage: userProfile.profileImageFile,
      planningToUse: howPlanToUse.planningToUse,
    };

    if (onboardingType === 'invitation') {
      return {
        ...commonFormData,
        firstName: userProfile.firstName,
        lastName: userProfile.lastName,
        password: userProfile.password,
        terms: userProfile.terms,
      };
    } else { // customer onboarding
      return {
        ...commonFormData,
        companyName: userProfile.companyName,
      };
    }
  }
);


export const selectTokenCheckState = createSelector(
  selectOnboardingState,
  (state) => ({
    loading: state.loading,
    error: state.error,
    success: state.success,
  })
);
